import { cn } from 'component-library';

type ListWidgetProps = {
  listItems: {
    text: string;
    style?: string;
  }[];
  className?: string;
};

export const UlListWidget = ({ listItems, className }: ListWidgetProps) => {
  return (
    <ul className={cn('ml-6 list-disc', className)}>
      {listItems.map((item, index) => (
        <li key={index} className={cn('typography-body1 text-text-secondary', item?.style)}>
          {item.text}
        </li>
      ))}
    </ul>
  );
};

export const OlListWidget = ({ listItems, className }: ListWidgetProps) => {
  return (
    <ol className={cn('ml-6 list-decimal', className)}>
      {listItems.map((item, index) => (
        <li key={index} className={cn('typography-body1 text-text-secondary', item?.style)}>
          {item.text}
        </li>
      ))}
    </ol>
  );
};
